export default __webpack_public_path__ + "stuffedCrustSausage.0e2ac25a.png";